"use client";

import { Carousel } from "react-bootstrap";
import { useRouter } from "next/navigation";
import newlogo from "../../../assets/images/logobeztla.webp";
import header from "../../../assets/images/saluthola_banner.jpg";
import "./style.css";

export function HomeHeader() {
  const router = useRouter();
  return (
    <header className="container">
      <div
        className="p-0 pt-2 pb-2 pe-auto"
        onClick={() => {
          router.push("/");
        }}
      >
        <img
          className="cursor-pointer"
          src={newlogo.src}
          alt="Salut Hola"
          width={250}
        />
      </div>
      <Carousel interval={5000} indicators={false} controls={false}>
        <Carousel.Item>
          <img
            src={header.src}
            className="d-block w-100"
            alt="Salut Hola"
            width="100%"
          />
        </Carousel.Item>
      </Carousel>
    </header>
  );
}
